// ----------------------------------------------------------------------

import { ITheme } from 'themes';

export default function Typography(theme: ITheme) {
  return {
    MuiTypography: {
      styleOverrides: {
        paragraph: {
          marginBottom: theme.spacing(2),
        },
        gutterBottom: {
          marginBottom: theme.spacing(1),
        },
      },
    },
  };
}
